import images from './images';

const hotDrinks = [
  {
    title: 'Hot Chocolate',
    price: '$5.00',
  },
  {
    title: 'White Chocolate',
    price: '$2.99',
  },
  {
    title: 'Vanilla Tea',
    price: '$4.99',
  },
  {
    title: 'Green Tea',
    price: '$1.99',
  },
  {
    title: 'Chamomiel Tea',
    price: '$2.99',
  },
];

const coffee = [
  {
    title: 'Americano',
    price: '$2.99',
  },
  {
    title: "Cappuccino",
    price: '$1.99',
  },
  {
    title: 'Latte',
    price: '$1.99',
  },
  {
    title: 'Espresso',
    price: '$1.99',
  },
  {
    title: 'Mocha',
    price: '$2.99',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Best Coffee',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'Best Food',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Fantastic Sweets',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { hotDrinks, coffee, awards };